var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NumericResultBase',{attrs:{"value":_vm.result ? _vm.result.detailedScore : null},scopedSlots:_vm._u([{key:"value",fn:function(ref){
var roundedScore = ref.value.roundedScore;
return [_vm._v("\n    "+_vm._s(roundedScore)+"\n  ")]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }